module.exports = __webpack_public_path__ + "static/android-c5d15e9962ceece87f5006c0315752c8.jpg";